import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { addppointmentservice } from './addappointment.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AppointmentService } from 'app/upgrade/appointment.service';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { SearchApptDialogComponent } from '../search-appt-dialog/search-appt-dialog.component';
import { SearchPtDialogComponent } from '../search-appt-dialog/search-pt-dialog.component';

import { DatePipe } from '@angular/common';
import { AuthService } from 'app/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { PatientFieldsModel } from 'app/table-list/Models/patient_mendatory_fields_config.model';

import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';

export interface IGetServiceData {
  pkServiceId: number;
  fkCategoryId: number;
  serviceName: string
  fkTestTypeId: number;
}

export interface IApptType {
  PKApptTypeId: number;
  ApptType: string;

}

@Component({
  selector: 'app-addappointment',
  templateUrl: './addappointment.component.html',
  styleUrls: ['./addappointment.component.scss']
})
export class AddappointmentComponent implements OnInit {
  @ViewChild('defaultauto', { static: false }) private defaultautoRef: ElementRef;
  @ViewChild('autofax', { static: false }) private autofaxRef: ElementRef;
  tdate = this.authService.getServerDate;
  public GetServiceData = [];
  animal: string;
  dobDate: string;
  yearList: string;
  yearAge: number;
  strDate: string;
  strOther: string;
  maxDate: any;


  patient_mendatory_fields: PatientFieldsModel[] = [];
  public selectedDate = this.authService.getServerDate;
  vipselected = false;
  checkgender:boolean=true;
  user_validated = "";
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<AddappointmentComponent>, public authService: AuthService, public translate: TranslateService,
    public langservice: LanguageService, public http: HttpClient, public appservice: AppointmentService, public opdvisitService: OpdVisitService, public AddAppointmentService: addppointmentservice,
    public dashboardService: DashboardService, public addappservice: addppointmentservice, private datePipe: DatePipe) {
    dialogRef.disableClose = true;
    translate.addLangs(['en', 'fr', 'hi']);
    // translate.setDefaultLang('hi');
    // this.langservice.setlang
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }

    console.log('current-language', this.langservice.setlang)
  }

  ngOnInit() {
    this.maxDate = this.authService.getServerDate;
   
    this.opdvisitService.apptdetail.pkAppointmentId == 0;
    //this.opdvisitService.apptdetail.contactNo="";
    this.opdvisitService.apptdetail.mobileNo = "";
    this.opdvisitService.apptdetail.fkCity = 0;
    this.opdvisitService.apptdetail.sex = "M";
    this.opdvisitService.apptdetail.fkTakenOnId = 578;
    this.fill_tab1_dd();
    this.get_patients_fields_config();
    this.dashboardService.get_otherinformation_tab_dd('VIPREF');
    this.opdvisitService.is_nameEdit = false;
    this.opdvisitService.is_surNameEdit = false;

  }
  getstates(countryid: number, option: number) {
    
     this.opdvisitService.stateid=0;
     this.opdvisitService.districtid =0;
     this.opdvisitService.apptdetail.fkCityId=0;
    this.opdvisitService.getstates(countryid, option);
  }

  getcities(disid: number, option: number) {
    this.opdvisitService.apptdetail.fkCityId=0;
    this.opdvisitService.getcities(disid, option);
  }
  getarea(cityid: number, option: number) {
    console.log("cityid " + cityid)
    this.opdvisitService.getareas(cityid, option);
  }
  getdistricts(stateid: number, option: number) {
    this.opdvisitService.districtid =0;
     this.opdvisitService.apptdetail.fkCityId=0;
    this.opdvisitService.getdistricts(stateid, option);
  }
  fill_gender_and_careof(initials: string) {

    var selectedinitials = this.opdvisitService.initials.find(item => item.initialName == initials);
    this.opdvisitService.apptdetail.sex = selectedinitials.sex;

    if (selectedinitials.sex!=" ") {
      this.opdvisitService.apptdetail.sex = selectedinitials.sex;
      this.checkgender=true;
    
    }else if(selectedinitials.sex==" "){
      this.checkgender=false;
      this.opdvisitService.apptdetail.sex = selectedinitials.sex;
    }
    this.opdvisitService.apptdetail.careofType = selectedinitials.careof;
    //alert(selectedinitials.sex);
    //this.opdvisitService.patientdetails.careofType = selectedinitials.careof;
    //console.log("initials " + initials+" sex "+selectedinitials.sex);
  }
  fill_tab1_dd() {
    this.addappservice.GetServiceData().subscribe(data => this.GetServiceData = data);
    this.opdvisitService.getcountries();
    this.opdvisitService.getinitials();
    this.opdvisitService.getpartymaster();
    this.opdvisitService.getpersonmaster('APPOINTMENT',0);
    this.AddAppointmentService.ApptType_info();

    // this.dashboardService.getall_doctors().
    //   subscribe(data => this.success_doctors(data), err => this.failed_doctors(err));;

  }
  // success_doctors(data) {
  //   this.opdvisitService.doctors = data;
  // }
  // failed_doctors(err) {


  // }

  //SearchDialog for Patient Search from Patient Registration
  opensearchPtDialog(): void {
    //   this.open_loader_Dialog();
    // this.dashboardService.showspinner = true;
    this.opdvisitService.get_top_200_patients().
      subscribe(data => this.success_top_200pt_patients(data), err => this.failed_top_200pt_patients(err));
  }

  success_top_200pt_patients(data) {

    //this.dialog.closeAll();
    // this.dashboardService.showspinner = false;
    if (this.opdvisitService.WinsCount == 0) {
      // this.opdvisitService.apptdetail = data;
      // this.opdvisitService.doctors;

      const dialogRef = this.dialog.open(SearchPtDialogComponent, {
        panelClass: 'full-width-dialog',
        maxWidth: '100vw !important',
        // height: '600px',
        width: '90%',
      });

      dialogRef.afterClosed().subscribe(result => {
        this.opdvisitService.getappdetails(this.opdvisitService.apptdetail.fkRegId);
        //pid = result;
      });
      this.opdvisitService.WinsCount = this.opdvisitService.WinsCount + 1;
    }

  }

  failed_top_200pt_patients(err) {
    // alert("close It");

    this.dialog.closeAll();
    // this.dashboardService.showspinner = false;

  }
  //

  onKeyDown(event) {
    //   alert("Pressed-"+event.key);
    console.log(event);
    return;
  }

  onNoClick(): void {

    this.dialogRef.close();
  }

  // savedetails() {

  //   if (this.opdvisitService.patientdetails.pkRegId == 0 ||
  //     this.opdvisitService.patientdetails.pkRegId == null) {
  //     this.opdvisitService.savepatientdetails();
  //   }
  //   else if (this.opdvisitService.patientdetails.pkRegId > 0) {
  //     console.log("progress");
  //     this.opdvisitService.updatepatient();
  //   }

  // }
  KeyPressMe(event) {
    let str = "1234567890/\.,*&^%$#@`~!(){}[]";
    //let str = "Hello World";

    for (var char of str) {
      //  console.log(char); // prints chars: H e l l o  W o r l d
      //this.strOther=char;
      if (event.key == char) {

        //alert("This is not allowed!");
        this.strOther = "";
      }
    }

  }

  PressForDate(event) {
    let strDate = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.,*&^%$#@`~!(){}[]";
    //let str = "Hello World";

    for (var char of strDate) {
      //  console.log(char); // prints chars: H e l l o  W o r l d
      //this.strOther=char;
      if (event.key == char) {
        //alert("Mai yaahu hu..."+event.key);
        this.opdvisitService.apptdetail.dob = "";
        console.log(this.opdvisitService.apptdetail.dob);
      }
    }

  }
  //Patient Configuration
  get_patients_fields_config() {
    this.opdvisitService.getPatientConfig()
      .subscribe(

        data => this.success_config(data), err => this.error_config(err)

      )
  }
  success_config(data) {

    //  this.showreg_form = true;
    this.patient_mendatory_fields = data;
    console.log("testing" + this.patient_mendatory_fields[0].mandatoryMobile);
    this.opdvisitService.apptdetail.fkTakenOnId = 578;
    // alert(this.patient_mendatory_fields[0].fK_CityId);
    this.opdvisitService.get_appt_city_district_state_country(this.patient_mendatory_fields[0].fK_CityId, 1);
    //this.opdvisitService.apptdetail.fkCityId=parseInt(this.patient_mendatory_fields[0].fK_CityId);
    this.opdvisitService.apptdetail.initial = "Mr."
    this.opdvisitService.apptdetail.fkApptTypeId = 1;
    this.opdvisitService.apptdetail.fkRefById = 1;

    setTimeout(() => {
      this.defaultautoRef.nativeElement.focus();
    }, 0);
    //console.log ("config works");
    console.log(data);
  }
  error_config(err) {

  }
  //
  chkDate(event) {
    if (this.opdvisitService.apptdetail.dob == null) {
      //alert("Invalid Date");
      this.opdvisitService.apptdetail.dob = " ";
      this.dashboardService.openSnackBar("Invalid Date", "OK");
      return;
    }

  }

  validate_initial() {
    if (this.patient_mendatory_fields[0].mandatoryInitial == true) {
      if (this.opdvisitService.apptdetail.initial == null || this.opdvisitService.apptdetail.initial == "") {
        this.user_validated = this.user_validated + " " + "Initial, " + " \n";
      }
      this.validate_gender();
    }
  }
  Validate_firstName() {
    if (this.opdvisitService.apptdetail.firstName == null || this.opdvisitService.apptdetail.firstName == "") {
      this.user_validated = this.user_validated + " " + "First Name, " + " \n";
    }
  }
  Validate_appType() {
    if (this.opdvisitService.apptdetail.fkApptTypeId == null) {
      this.user_validated = this.user_validated + " " + "App Type, " + " \n";
    }
  }

  validate_DOBAge() {
    if (this.opdvisitService.apptdetail.ageYear == null && this.opdvisitService.apptdetail.ageMonth == null && this.opdvisitService.apptdetail.ageDays == null) {
      // this.user_validated += 1;
      this.user_validated = this.user_validated + " " + "Age, " + " \n";
    }
  }
  validate_mobile() {
    if (this.patient_mendatory_fields[0].mandatoryMobile == true) {
      if (this.opdvisitService.apptdetail.mobileNo == null) {
        this.user_validated = this.user_validated + " " + "Mobile No. , " + " \n";
      } else if (this.digits_count(Number(this.opdvisitService.apptdetail.mobileNo)) != 10) {
        this.user_validated = this.user_validated + " " + "Enter 10 Digit MobileNo , " + " \n";
      }
    }
  }

  validate_address() {
    if (this.patient_mendatory_fields[0].mandatoryAddress == true) {
      if (this.opdvisitService.apptdetail.address == null || this.opdvisitService.apptdetail.address == "") {
        // this.user_validated += 1;
        this.user_validated = this.user_validated + " " + "Address, " + " \n";
      }
    }
  }

  validate_countryName() {
    if (this.opdvisitService.countryid == null || this.opdvisitService.countryid == 0) {
      this.user_validated = this.user_validated + " " + "Country Name, " + " \n";
    }
  }
  validate_stateName() {
    if (this.opdvisitService.stateid == null || this.opdvisitService.stateid == 0) {
      this.user_validated = this.user_validated + " " + "State Name, " + " \n";
    }
  }
  validate_DistrictName() {
    if (this.opdvisitService.districtid == null || this.opdvisitService.districtid == 0) {
      this.user_validated = this.user_validated + " " + "District Name, " + " \n";
    }
  }
  validate_CityName() {
    if (this.opdvisitService.apptdetail.fkCityId == null || this.opdvisitService.apptdetail.fkCityId == 0) {
      this.user_validated = this.user_validated + " " + "City Name, " + " \n";
    }
  }

  validate_gender() {
    if (this.checkgender != true) {
      if (this.opdvisitService.patientdetails.sex == null || this.opdvisitService.patientdetails.sex == " ") {
        this.user_validated = this.user_validated + " " + "GENDER, " + " \n";
      }
    }
  }
  validate_viType(){
    if (this.opdvisitService.apptdetail.isVip == true) {
      if (this.opdvisitService.apptdetail.fkViprefId == null || this.opdvisitService.apptdetail.fkViprefId == 0) {
        this.user_validated = this.user_validated + " " + "VIP Type, " + " \n";
      }
    }
  }

  check_user_validation() {
    this.validate_initial();
    this.Validate_firstName();
    this.Validate_appType();
    this.validate_DOBAge();
    this.validate_mobile();
    this.validate_address();
    this.validate_countryName();
    this.validate_stateName();
    this.validate_DistrictName();
    this.validate_CityName();
    this.validate_viType();
    if (this.user_validated != "") {
      const newstring = this.user_validated.substring(0, this.user_validated.length - 2);
      this.dashboardService.
        openSnackBar_regform("Please Check all Mandatory Fields Marked with * " + " " + newstring, "OK");
      this.user_validated = "";
    } else {
      this.opdvisitService.apptdetail.firstName =this.checkTitlecase(this.opdvisitService.apptdetail.firstName);
      if(this.opdvisitService.apptdetail.lastName !=null && this.opdvisitService.apptdetail.lastName !=undefined && this.opdvisitService.apptdetail.lastName !=""){
        this.opdvisitService.apptdetail.lastName =this.checkTitlecase(this.opdvisitService.apptdetail.lastName);
      }
      this.savedetails();
    }
  }
  checkTitlecase(value){
    return  value = (value.length > 1) ? value[0].toUpperCase() + value.substr(1).toLowerCase() : value.toUpperCase();
    }
  savedetails() {
     
    if (this.opdvisitService.apptdetail.ageYear <= 200) {
      if (this.opdvisitService.apptdetail.fkServiceId == 0 || this.opdvisitService.apptdetail.fkServiceId == null || this.opdvisitService.apptdetail.fkServiceId == undefined) {
        this.opdvisitService.apptdetail.fkServiceId = 0;
      }
      const currrentdate = this.authService.localDate;
      if (Date.parse(this.datePipe.transform(currrentdate, "yyyy-MM-dd").toString()) == Date.parse(this.datePipe.transform(this.opdvisitService.appSelectDate, "yyyy-MM-dd").toString())) {
        let xHr = currrentdate.getHours();
        let xMin = currrentdate.getMinutes();
        let yTime = this.convertTo24Hour(this.opdvisitService.apptdetail.apptTime);
        let ApptX = yTime.split(":");

        let RealTime = (xHr * 60) + xMin;
        let ApptTime = (parseInt(ApptX[0]) * 60) + parseInt(ApptX[1]);
        if (ApptTime < RealTime) {
          this.dashboardService.openSnackBar("Back time is Not Allowed", "Ok");
        } else {
          this.open_loader_Dialog();
          if (this.opdvisitService.apptdetail.pkAppointmentId == 0 || this.opdvisitService.apptdetail.pkAppointmentId == null) {
            this.opdvisitService.apptdetail.pkAppointmentId = 0;
          }
          if (this.opdvisitService.apptdetail.pkAppointmentId == 0) {
            this.GetMoreApptCount();
          }
          else {
            this.opdvisitService.updateappt(this.authService.Loggeduser.branchid);
          }
        }
      }
      else {
        this.open_loader_Dialog();
        if (this.opdvisitService.apptdetail.pkAppointmentId == 0 || this.opdvisitService.apptdetail.pkAppointmentId == null) {
          this.opdvisitService.apptdetail.pkAppointmentId = 0;
        }

        if (this.opdvisitService.apptdetail.pkAppointmentId == 0) {
          this.GetMoreApptCount();
          //    this.opdvisitService.get_futureApptCount();

          // alert(this.opdvisitService.futureApptCount);


          // this.appservice.Doctor_time_info().subscribe(data => this.successlist(data)
          // , err => this.errlist(err));

        }
        else {
          // alert("No Zero");
          this.opdvisitService.updateappt(this.authService.Loggeduser.branchid);
          // this.appservice.showRec();
        }
        // }
        // else if (this.opdvisitService.apptdetail.firstName.length > 0) 
        // {
        //   console.log("progress");

        // }
      }
    } else {
      this.dashboardService.openSnackBar("Age Can't More Than 200 Year", "OK");
    }
  }
  digits_count(n) {
    var count = 0;
    if (n >= 1) ++count;

    while (n / 10 >= 1) {
      n /= 10;
      ++count;
    }

    return count;
  }
  letterOnly(event) {

    var charCode = event.keyCode;

    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 46 || charCode == 32)

      return true;
    else
      return false;
  }
  reMovedata(event) {
    if (event == "") {
      this.clearfields();
    }

  }
  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }
  
 
  // errlist(err){

  // }
  // successlist(data){
  //   this.UpgradeComponent.Doctor_time_info= data;
  //   this.dialog.closeAll();
  // }
  open_loader_Dialog(): void {

    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        //  id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //pid = result;
    });
  }

  opensearchDialog(): void {
    // alert("started");
    //  this.open_loader_Dialog();
    // this.dashboardService.showspinner = true;
    this.get_top_200_patients();

  }

  //om
  GetMoreApptCount() {
   
    var appointmentdata;
    if (this.appservice.docotrSlot.length != 0) {
      var checkappointmentPatient;
      checkappointmentPatient = this.appservice.docotrSlot.filter(item => (item.patientId == this.opdvisitService.apptdetail.fkRegId && item.isCancelled == false));
      if (checkappointmentPatient.length != 0) {
        appointmentdata = checkappointmentPatient[0].patientId;
      } else {
        appointmentdata = null;
      }

    } else {
      appointmentdata = null;
    }

    if (appointmentdata != this.opdvisitService.apptdetail.fkRegId || appointmentdata == null) {
      if (this.opdvisitService.apptdetail.fkRegId != null) {
       
       this.opdvisitService.getfutureAppt().
          subscribe(

            data => this.success_count(data), err => this.error_count(err)

          )
      }
      else {
        this.opdvisitService.saveapptdetails(this.authService.Loggeduser.branchid);
      }
    } else {
     
      this.dashboardService.openSnackBar("This Patient is already booked Appointment", "OK");
      this.opdvisitService.showspinner = false;
    }
  }




  success_count(data) {
    this.opdvisitService.showspinner = false;
    // alert("working till here");
    this.opdvisitService.futureApptCount = data;

    if (this.opdvisitService.futureApptCount > 0) {
      this.dashboardService.openSnackBar("Patient already got appointment for future, do you want to continue", "OK");
      this.opdvisitService.futureApptCount = 0;
      this.opdvisitService.saveapptdetails(this.authService.Loggeduser.branchid);
    }
    else {

      this.opdvisitService.saveapptdetails(this.authService.Loggeduser.branchid);
    }
  }
  error_count(err) {
    this.opdvisitService.showspinner = false;
   // this.dialog.closeAll();
  }
  get_top_200_patients() {
    // this.dialog.closeAll();
    // this.dashboardService.showspinner = false;
    //  this.opdvisitService.patients = data;

    //alert("In function");
    //console.log("patients successfully loaded");

    // call dialogue once data get loaded inside success
    const dialogRef = this.dialog.open(SearchApptDialogComponent, {

      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      // height: '80%',
      width: '90%',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.opdvisitService.apptdetail.fkPartyId=this.opdvisitService.apptdetail.fK_PartyId;
      this.defaultautoRef.nativeElement.focus();
      this.vipselected=true;

      this.animal = result;
    });

  }

  failed_top_200_patients(err) {
    this.dialog.closeAll();
    // this.dashboardService.showspinner = false;

  }

  showAge(dobYear, dobMonth, dobDay) {
    var bthDate, curDate, days;
    var ageYears, ageMonths, ageDays;
    bthDate = new Date(dobYear, dobMonth - 1, dobDay);
    curDate = this.authService.localDate;
    if (bthDate > curDate) return;
    days = Math.floor((curDate - bthDate) / (1000 * 60 * 60 * 24));
    ageYears = Math.floor(days / 365);
    ageMonths = Math.floor((days % 365) / 31);
    ageDays = days - (ageYears * 365) - (ageMonths * 31);
    if (ageYears > 0) {
      document.write(ageYears + " year");
      if (ageYears > 1) document.write("s");
      if ((ageMonths > 0) || (ageDays > 0)) document.write(", ");
    }
    if (ageMonths > 0) {
      document.write(ageMonths + " month");
      if (ageMonths > 1) document.write("s");
      if (ageDays > 0) document.write(", ");
    }
    if (ageDays > 0) {
      document.write(ageDays + " day");
      if (ageDays > 1) document.write("s");
    }
    var dtrAge = ageMonths, ageMonths, ageDays
    return dtrAge;
  }

  // onSelectDate(event)
  // {

  //    console.log(event.value);

  //    this.dobDate = event.value;

  //    const dobStringList = event.value.toDateString();
  //     const dateValueList = dobStringList.split(' ');
  //     this.yearList = dateValueList[3];

  //     this.dobDate = dateValueList[0] + ',' + ' ' + dateValueList[1] + ' ' + dateValueList[2];

  //    this.dobDate =this.yearList +"-"+dateValueList[1] + '-' + dateValueList[2];

  //    this.strDate= this.showAge(this.yearList,dateValueList[1], dateValueList[2]);
  //    this.strDate== this.datePipe.transform(this.appservice.selectedDateList,"yyyy-MM-dd");


  // }
  getVIP(event) {

    this.opdvisitService.apptdetail.isVip = event.checked;
   
    //alert("Checked VIP "+ this.opdvisitService.apptdetail.isVip);
  }

  enablevipdd(event) {
    if (event.checked == true) {
      this.vipselected = true;
    } else {
      this.vipselected = false;
      this.opdvisitService.apptdetail.fkViprefId == null;
    }
  }

  getage(selecteddate: string) {

    // let container = selecteddate.split("/", 3);

    // let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];

    // let currenttime = this.datePipe.transform(new Date(), "hh:mm:ss");
  
    // let dateofbirth = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");

    // let currentdate = this.datePipe.transform(new Date, "yyyy-MM-dd");

    // this.getDataDiff(new Date(dateofbirth), new Date(currentdate));
    const checkcdate= this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let currentdate = this.authService.getServerDate;
    if(currentdate >= checkcdate){
      this.getDataDiff(new Date(selecteddate), new Date(currentdate));
    }else{
      this.opdvisitService.apptdetail.dob=this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
      this.opdvisitService.apptdetail.ageYear = 0;
      this.opdvisitService.apptdetail.ageMonth = 0;
      this.opdvisitService.apptdetail.ageDays = 0;
    }
  }

  // getdob(typedValue: number){

  //   const tdate = new Date();
  //   const dobyear = tdate.getFullYear() - typedValue;
  // let datestring = tdate.getUTCDate() + "/" + (tdate.getMonth()) + "/" + dobyear;
  // let container = datestring.split("/", 3);

  // let selecteddate_converted = container[1] + "/" + container[0] + "/" + container[2];

  // this.opdvisitService.apptdetail.dob = this.datePipe.transform(selecteddate_converted, "yyyy-MM-dd");

  // }
  // getdob() {
  //   var tdate = new Date();
  //   tdate.setDate(tdate.getUTCDate() - this.opdvisitService.apptdetail.ageDays);
  //   tdate.setMonth(tdate.getMonth() - this.opdvisitService.apptdetail.ageMonth);
  //   tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.apptdetail.ageYear);
  //   this.opdvisitService.apptdetail.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");


  //   console.log("new date " + this.opdvisitService.apptdetail.dob);

  // }

  // DOb validation
  getdob(type: any) {

    switch (type) {
      case 1: {
        var tdate = this.authService.localDate;
        if (this.opdvisitService.apptdetail.ageYear == null || this.opdvisitService.apptdetail.ageYear == undefined) {
          this.opdvisitService.apptdetail.ageYear = 0;
        }
        this.opdvisitService.apptdetail.ageMonth = 0;
        this.opdvisitService.apptdetail.ageDays = 0;
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.apptdetail.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.apptdetail.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.apptdetail.ageYear);
        this.opdvisitService.apptdetail.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 2: {
        var tdate =this.authService.localDate;
        if (this.opdvisitService.apptdetail.ageMonth > 11 || this.opdvisitService.apptdetail.ageMonth <= 0) {
          this.dashboardService.openSnackBar("Please enter months in between 0 to 12", "OK");
          this.opdvisitService.apptdetail.ageMonth = null;
          return false;
        }
        if (this.opdvisitService.apptdetail.ageYear == undefined || this.opdvisitService.apptdetail.ageYear == null) {
          this.opdvisitService.apptdetail.ageYear = 0;
        }
        this.opdvisitService.apptdetail.ageDays = 0;
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.apptdetail.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.apptdetail.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.apptdetail.ageYear);
        this.opdvisitService.apptdetail.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
        break;
      }
      case 3: {

        var tdate = this.authService.localDate;
        if (this.opdvisitService.apptdetail.ageDays > 31 || this.opdvisitService.apptdetail.ageDays < 0) {
          this.dashboardService.openSnackBar("Please enter days in between 0 to 31", "OK");
          this.opdvisitService.apptdetail.ageDays = null;
          return false;
        }
        if ((this.opdvisitService.apptdetail.ageMonth == undefined || this.opdvisitService.apptdetail.ageMonth == null) && (this.opdvisitService.patientdetails.ageYear == undefined || this.opdvisitService.patientdetails.ageYear == null)) {
          this.opdvisitService.apptdetail.ageMonth = 0;
          this.opdvisitService.apptdetail.ageYear = 0;
        }
        tdate.setDate(tdate.getUTCDate() - this.opdvisitService.apptdetail.ageDays);
        tdate.setMonth(tdate.getMonth() - this.opdvisitService.apptdetail.ageMonth);
        tdate.setFullYear(tdate.getFullYear() - this.opdvisitService.apptdetail.ageYear);
        this.opdvisitService.apptdetail.dob = this.datePipe.transform(tdate, "yyyy-MM-dd");
      }
    }



    // console.log("new date " + this.opdvisitService.apptdetail.dob);

  }


  getDataDiff(start, end) {


    let years: number = 0, months: number = 0, days: number;
    // Day diffence. Trick is to use setDate(0) to get the amount of days
    // from the previous month if the end day less than the start day.
    if (end.getDate() < start.getDate()) {
      months = -1;
      let datePtr: Date = new Date(end);
      datePtr.setDate(0);
      days = end.getDate() + (datePtr.getDate() - start.getDate());
    } else {
      days = end.getDate() - start.getDate();
    }

    if (end.getMonth() < start.getMonth() || (end.getMonth() === start.getMonth() && end.getDate() < start.getDate())) {
      years = -1;
      months += end.getMonth() + (12 - start.getMonth());
    } else {
      months += end.getMonth() - start.getMonth();
    }

    years += end.getFullYear() - start.getFullYear();

    this.opdvisitService.apptdetail.ageYear = years;
    this.opdvisitService.apptdetail.ageMonth = months;
    this.opdvisitService.apptdetail.ageDays = days;


  }

  getToday(): string {
    return this.authService.localDate.toISOString().split('T')[0]
  }
  clearfields() {

    // this.addresschecked = false;

    this.opdvisitService.apptdetail = {};
    this.opdvisitService.apptdetail.initial = 'Mr.';

    this.opdvisitService.apptdetail.fkCityId = 0;
    this.opdvisitService.apptdetail.fkConsultantId = this.opdvisitService.DoctorId;
    this.opdvisitService.stateid = 0;
    this.opdvisitService.districtid = 0;
    this.opdvisitService.countryid = 0;
    this.opdvisitService.apptdetail.fkOccupationId = 0;
    this.opdvisitService.apptdetail.fkPartyId = 0;
    this.opdvisitService.apptdetail.fkRefById = 0;
    this.opdvisitService.apptdetail.fkServiceId = 0;
    this.opdvisitService.apptdetail.fkTakenOnId = 0;
    this.opdvisitService.apptdetail.isCancelled = null;
    this.opdvisitService.apptdetail.isSap = null;
    this.opdvisitService.apptdetail.lastName = null;
    this.opdvisitService.apptdetail.firstName = null;
    this.opdvisitService.apptdetail.fkRegId = null;
    this.opdvisitService.apptdetail.pkAppointmentId = null;
    this.opdvisitService.apptdetail.sex = null;
    this.opdvisitService.apptdetail.address = null;
    this.opdvisitService.apptdetail.ageDays = null;
    this.opdvisitService.apptdetail.ageMonth = null;
    this.opdvisitService.apptdetail.ageYear = null;
    //
    this.opdvisitService.apptdetail.fkForBranchId = null;
    this.opdvisitService.apptdetail.daySrNo = null;
    this.opdvisitService.apptdetail.fkApptTypeId = null;
    this.opdvisitService.apptdetail.dob = null;
    this.opdvisitService.apptdetail.emailAddress = null;
    this.opdvisitService.apptdetail.remarks = null;
    this.opdvisitService.apptdetail.isConfirm = null;
    this.opdvisitService.apptdetail.isCancelled = null;
    this.opdvisitService.apptdetail.tokenNo = null;
    this.opdvisitService.states = [];
    this.opdvisitService.districts = [];
    this.opdvisitService.cities = [];
    this.opdvisitService.areas = [];
    this.opdvisitService.apptdetail.apptTime = this.opdvisitService.appservice.times;
    this.opdvisitService.is_nameEdit = false;
    this.opdvisitService.is_surNameEdit = false;
    this.set_default_values();
  }

  set_default_values() {
    if (this.patient_mendatory_fields[0].fK_InitialId != null) {
      for (let initial of this.opdvisitService.initials) {
        if (initial.pK_InitialId == this.patient_mendatory_fields[0].fK_InitialId) {
          this.opdvisitService.patientdetails.initial = initial.initialName;
        }
      }
    }

    if (this.patient_mendatory_fields[0].fL_SourceId != null) {
      this.opdvisitService.patientdetails.fkSourceId = this.patient_mendatory_fields[0].fL_SourceId;
    }
    if (this.patient_mendatory_fields[0].fK_CityId != null) {
      this.opdvisitService.get_city_district_state_country(this.patient_mendatory_fields[0].fK_CityId, 1);
    }
  }
  
  convertTo24Hour(time) {
    let hours = parseInt(time.substr(0, 2));
    if (time.indexOf('AM') != -1 && hours == 12) {
      time = time.replace('12', '0');
    }
    if (time.indexOf('PM') != -1 && hours < 12) {
      time = time.replace(hours, (hours + 12));
    }
    return time.replace(/(AM|PM)/, '');
  }
}